import angular from 'angular'

/**
 * The defacto currency filter used by Vend to manipulate angular values based on the user's locale.
 *
 * @module vend.ui.vdCurrencyFilter
 */
angular
  .module('vend.ui')
  .filter('vdCurrency', function (vdCurrencySettings, currencyFilter) {
    return function (value, symbol, fractionSize) {
      const currencyConfig = vdCurrencySettings.settings

      if (typeof value === 'string') {
        // Cast value to number as VendNumber and BigNumber sometimes return a string.
        value = Number(value)

        if (Number.isNaN(value)) {
          return ''
        }
      }

      symbol = symbol || currencyConfig.symbol
      fractionSize = fractionSize || currencyConfig.fractionSize
      const suffix = currencyConfig.suffix

      return currencyFilter(value, symbol, fractionSize, suffix)
    }
  })
